/* esm.sh - @noble/curves@2.0.1/secp256k1 */
export * from "/*@noble/curves@2.0.1/esnext/secp256k1.mjs";
